import styled from 'styled-components';
import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  position: relative;
`;

const ChildContainer = styled.div``;

const Tooltip = styled.div`
  position: absolute;
  bottom: 3rem;
  left: 1rem;

  padding: 1rem 2rem;

  border-radius: 0.3rem;
  background-color: ${pickColor('colmarRed')};
`;

const Arrow = styled.div`
  position: absolute;
  bottom: -0.5rem;

  width: 1.2rem;
  height: 1.2rem;

  background-color: ${pickColor('colmarRed')};

  rotate: 45deg;
`;

export { Container, Tooltip, Arrow, ChildContainer };
